$(function () {
	var $win = $(window);
	var $doc = $(document);


	window.Shopify = window.Shopify || {};
	var Shopify = window.Shopify;
  // ---------------------------------------------------------------------------
  // Money format handler
  // ---------------------------------------------------------------------------
  Shopify.money_format = Shopify.money_format || '${{amount}}';
  Shopify.formatMoney = Shopify.formatMoney || function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || Shopify.money_format || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);
    var placeholder = (match && match[1]) ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  };

	/* Login */
	$(".forgotten-pass, .loginfrom-link").on("click", function (e) {
		e.preventDefault();
		var $this = $(this);
		var targetString = $this.attr("href").replace("#", "");
		$(".".concat(targetString)).show();
		$this.closest("form").parent().hide();
	});
	$(".addresses__actions .btn--new, .form--address-new .btn--cancel").on(
		"click",
		function (e) {
			e.preventDefault();
			var $this = $(this);
			var targetString = $this.attr("href").replace("#", "");
			$(".".concat(targetString)).toggle();
		},
	);
	$("#sortBy").on("change", function () {
		Shopify.queryParams = {};
		var $this = $(this);
		var thisVal = $this.val();

		if (location.search) {
			var getArgumentsArray = location.search.substr(1).split("&");
			getArgumentsArray.map(function (ele) {
				var eleArray = ele.split("=");
				Shopify.queryParams[decodeURIComponent(eleArray[0])] =
					decodeURIComponent(eleArray[1]);
			});
		}

		Shopify.queryParams.sort_by = thisVal;
		location.search = jQuery.param(Shopify.queryParams);
	});
	$(".product-single__variants").on("change", function () {
		var $this = $(this);
		var thisPrice = $this.find("option:selected").data("price");
		$(".product__price").html(thisPrice);
	});
	$('select[name="address[country]"]').each(function () {
		var $this = $(this);
		var thisID = $this.attr("id");
		var province = $this
			.closest("form")
			.find('select[name="address[province]"]');
		var provinceID = province.attr("id");
		var provinceHolderID = province.closest(".form__row").attr("id");
		new Shopify.CountryProvinceSelector(thisID, provinceID, {
			hideElement: provinceHolderID,
		});
	});


	// FORMS
	function updateLineItemQuantity(variantID, itemQuantity) {
			$.ajax({
					url: "/cart/change.js",
					type: "POST",
					dataType: "json",
					data: {
							quantity: itemQuantity,
							id: variantID,
					},
			}).done(function () {
					$.ajax({
							type: "GET",
							dataType: "html",
					}).done(function (response) {
							var $response = $(response);
							var $itemsHolder = $response.find(".section-cart");
							$(".section-cart").empty().append($itemsHolder.html());
					});
			});
	}

	function updateCartCount() {
			setTimeout(function () {
					jQuery.getJSON("/cart.js", function (cart) {
							let cartHtml = '<div class="item-count cart-count-bubble"><span aria-hidden="true">' + cart.item_count + '</span></div>';
							$('.site-header__cart .cart-count-bubble').remove();
							$('.site-header__cart').append(cartHtml);
					});
			}, 1000);
	}

	$doc.on("click", ".js-click", function (event) {
			event.preventDefault();
			var $this = $(this);
			var $element = $($this.attr("href"));

			if (!$element.length) return;

			// Определяем контекст
			var isStickyForm = $this.closest('.pdp-sticky-form').length > 0;

			// Общая логика активных состояний (изолированно для каждой формы)
			if (isStickyForm) {
					$(".pdp-sticky-form .js-click").removeClass("is-active");
			} else {
					$(".js-click").not(".pdp-sticky-form .js-click").removeClass("is-active");
			}

			$this.addClass("is-active");
			$element.toggleClass("is-expanded");

			// Общая логика для toggle и scroll
			if ($element.hasClass("js-toggle")) {
					$element.siblings(".js-toggle").removeClass("is-expanded");
					$element.addClass("is-expanded");
			}

			if ($element.hasClass("js-scroll-to") && $element.hasClass("is-expanded")) {
					$("html, body").stop().animate({
							scrollTop: $element.offset().top,
					});
			}

			// Логика quantity для обеих форм
			if ($element.hasClass("js-quantity") || $element.hasClass("js-product-quantity")) {
					var variantID = $element.data("variant-id");
					var maxVal = $element.attr("max");
					var currentVal = parseInt($element.val()) || 1;

					if ($this.hasClass("js-quantity-incr")) {
							var newVal = currentVal + 1;
							$element.val(newVal <= maxVal ? newVal : maxVal);
					} else if ($this.hasClass("js-quantity-decr")) {
							var _newVal = currentVal - 1;
							$element.val(_newVal > 0 ? _newVal : 1);
					}

					// Для js-quantity обновляем корзину, для js-product-quantity - нет
					if ($element.hasClass("js-quantity")) {
							updateLineItemQuantity(variantID, $element.val());
							updateCartCount();
					}
			}
	});

	$doc.on("change", ".js-quantity", function (event) {
			event.preventDefault();
			var $element = $(this);
			let currentVal = $element.val();

			if (!$element.length) return;

			if (!isNaN(currentVal) && currentVal > 0) {
					var variantID = $element.data("variant-id");
					updateLineItemQuantity(variantID, currentVal);
					updateCartCount();
			} else {
					$element.val($element.data("old-value"));
			}
	});

	$doc.on("focus", ".js-change", function() {
			$(this).data("old-value", $(this).val());
	});

	/** Add to cart function script **/
	$(document).on("submit", ".product__form, #pdp-sticky-form", function (e) {
			var body = $("body").attr("class");
			if (body.indexOf("template-cart") != -1) {
					return; // Allow default behavior on cart page
			}

			e.preventDefault();

			var $form = $(this);
			var selected_id = $form.find("[name=id]").val();
			var quantity = $form.find("[name=quantity]").val();
			var isStickyForm = $form.is("#pdp-sticky-form");

			// Determine button content based on form context
			var button_content = "Add to Cart";
			if ($(window).width() > 767 && !isStickyForm) {
					button_content = `<svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20" fill="none">
							<path fill="#fff" d="M22.047 2.5a.944.944 0 0 1 .74.352.813.813 0 0 1 .18.781l-1.801 8.125a.99.99 0 0 1-.34.527.885.885 0 0 1-.58.215H7.747l.4 1.875h11.263a.943.943 0 0 1 .74.352.814.814 0 0 1 .18.781l-.04.2c.254.227.457.504.595.812.137.31.207.643.203.98a2.37 2.37 0 0 1-.183.964 2.415 2.415 0 0 1-.558.813A2.635 2.635 0 0 1 18.53 20c-.679 0-1.331-.26-1.817-.723a2.413 2.413 0 0 1-.556-.814 2.37 2.37 0 0 1-.18-.963c0-.441.124-.874.36-1.25h-5.829c.234.377.358.81.356 1.25a2.37 2.37 0 0 1-.183.964 2.413 2.413 0 0 1-.558.813c-.236.235-.52.42-.831.545a2.519 2.519 0 0 1-.984.178 2.519 2.519 0 0 1-.985-.178 2.473 2.473 0 0 1-.832-.545 2.391 2.391 0 0 1-.556-.804 2.346 2.346 0 0 1-.184-.953 2.315 2.315 0 0 1 .175-.941c.123-.3.307-.57.541-.797L3.675 1.875H.479A.471.471 0 0 1 0 1.406V.469A.443.443 0 0 1 .14.137.463.463 0 0 1 .48 0h3.993a.94.94 0 0 1 .619.215.99.99 0 0 1 .34.527l.32 1.758h16.295ZM8.307 18.437a.94.94 0 0 0 .68-.273.9.9 0 0 0 .279-.664.883.883 0 0 0-.28-.664.922.922 0 0 0-.678-.273.94.94 0 0 0-.68.273.898.898 0 0 0-.28.664.882.882 0 0 0 .28.664.921.921 0 0 0 .68.273Zm10.226 0a.94.94 0 0 0 .679-.273.9.9 0 0 0 .279-.664.882.882 0 0 0-.28-.664.923.923 0 0 0-.678-.273.94.94 0 0 0-.68.273.898.898 0 0 0-.28.664.882.882 0 0 0 .28.664.922.922 0 0 0 .68.273Zm.92-7.812 1.398-6.25H6.15l1.239 6.25h12.063Z"/>
					</svg> Add to Cart`;
			}

			// Save original button content and disable button during AJAX call
			var $submitButton = $form.find("button[name=add], button[type=submit]");
			var originalContent = $submitButton.html();

			// Show loading state
			$submitButton.html("Adding...");
			$submitButton.prop("disabled", true);

			jQuery.ajax({
					type: "POST",
					url: "/cart/add.js",
					data: {
							quantity: quantity,
							id: selected_id,
					},
					dataType: "json",
					success: function () {
							//Update button content back to original
							$submitButton.html(originalContent);
							$submitButton.prop("disabled", false);

							updateCartCount();

							if (isStickyForm) {
									console.log('Товар добавлен из sticky формы');
							}
					},
					error: function () {
							alert("Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.");
							$submitButton.html(originalContent);
							$submitButton.prop("disabled", false);
					},
			});
	});

	// Cart item remove function
	$doc.on("click", ".js-line-item-remove", function (event) {
		event.preventDefault();
		var $this = $(this);
		$.ajax({
			url: $this.attr("href"),
			type: "GET",
			dataType: "html",
		}).done(function (response) {
			var $response = $(response);
			var $itemsHolder = $response.find(".section-cart");
			$(".section-cart").empty().append($itemsHolder.html());
			setTimeout(function () {
				jQuery.getJSON("/cart.js", function (cart) {
					let cartHtml = '<div class="item-count cart-count-bubble"<span aria-hidden="true">' + cart.item_count + '</span></div>';
							$('.site-header__cart .cart-count-bubble').remove();
							$('.site-header__cart').append(cartHtml);
				});
			}, 1000);
		});
	});

	// Product cards Add to cart function
	$(".js-add-to-cart").on("click", function (event) {
		event.preventDefault();
		$(this).parent(".js-product-form").submit();
	});

	$(document).on("submit", ".js-product-form", function (e) {
		var body = $("body").attr("class");
		if (body.indexOf("template-cart") != -1) {
		} else {
			e.preventDefault();
			var selected_id = $(this).find("[name=id]").val();
			var quantity = 1;
			var button_content = "Add to Cart";

			$(this).find(".product-card__button-text").html("Adding");
			jQuery.ajax({
				type: "POST",
				url: "/cart/add.js",
				data: {
					quantity: quantity,
					id: selected_id,
				},
				dataType: "json",
				success: function () {
					$("button[name=add]")
						.find(".product-card__button-text")
						.html(button_content);
					setTimeout(function () {
						jQuery.getJSON("/cart.js", function (cart) {
							let cartHtml = '<div class="item-count cart-count-bubble"<span aria-hidden="true">' + cart.item_count + '</span></div>';
							$('.site-header__cart .cart-count-bubble').remove();
							$('.site-header__cart').append(cartHtml);
						});
					}, 1000);
				},
				error: function () {
					alert(
						"Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.",
					);
					$("button[name=add]")
						.find(".product-card__button-text")
						.html("Add to Cart");
				},
			});
		}
	});

	// breadcrumbs-last-pages

	var currentUrl = window.location.pathname;
	var firstCookieKey = "rcgeeks_first_visited_page";
	var secondCookieKey = "rcgeeks_second_visited_page";
	var firstPageCookie = getCookie(firstCookieKey);
	var secondPageCookie = getCookie(secondCookieKey);

	function writeCookie(cookieValue) {
		if (firstPageCookie === "") {
			setCookie(firstCookieKey, cookieValue, 7);
		}

		if (firstPageCookie === cookieValue) {
			return;
		}

		if (firstPageCookie !== cookieValue) {
			setCookie(secondCookieKey, firstPageCookie, 7);
			setCookie(firstCookieKey, cookieValue, 7);
		}
	}

	function buildLinks($selector, targetCookie) {
		$selector
			.removeClass("hidden")
			.attr("href", targetCookie.split("||")[1])
			.text(targetCookie.split("||")[0])
			.next(".hidden")
			.removeClass("hidden");
	}

	function populateBreadcrumbs() {
		if (firstPageCookie !== "") {
			buildLinks($(".js-last-page"), firstPageCookie);
		}

		if (secondPageCookie !== "") {
			$(".js-pre-last-page")
				.removeClass("hidden")
				.next(".hidden")
				.removeClass("hidden");
		}

		if ($("body").hasClass("template-cart")) {
			var href = $(".js-last-page").attr("href");
			if (href == "/") {
				$(".hidebreadcrumb").addClass("hidden");
			}
		}

		if (currentUrl.indexOf("/cart") !== -1) {
			return;
		}

		writeCookie("".concat(pagetitle, "||").concat(currentUrl));
		// writeCookie("".concat(pageTitle, "||").concat(currentUrl));
	}
	var x = document.cookie;

	populateBreadcrumbs();

	//cookies.js

	function setCookie(cookieName, cookieValue, expiresDays) {
		var date = new Date();
		date.setTime(date.getTime() + expiresDays * 24 * 60 * 60 * 1000);
		var expires = "expires=" + date.toUTCString();
		document.cookie =
			cookieName + "=" + cookieValue + ";" + expires + ";path=/";
	}
	function getCookie(cookieName) {
		var name = cookieName + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var cookieArray = decodedCookie.split(";");

		for (var i = 0; i < cookieArray.length; i++) {
			var cookie = cookieArray[i];

			while (cookie.charAt(0) == " ") {
				cookie = cookie.substring(1);
			}

			if (cookie.indexOf(name) == 0) {
				return cookie.substring(name.length, cookie.length);
			}
		}

		return "";
	}

	//  dropdown
	$(".countdown").each(function () {
		var $this = $(this);
		var eventDate = $this.data("time");
		if (eventDate.length) {
			$this.countdown({
				date: eventDate,
			});
		}
	});

	if ($(".tabs").length) {
		$(".tabs .tabs__nav li").on("click", function (e) {
			e.preventDefault();

			// Activate menu item
			$(this)
				.addClass("active")
				.closest(".tabs__nav")
				.find("li")
				.not($(this))
				.removeClass("active");

			// Activate tab content
			var tabTarget = $(this).data("target");
			var $activeTab = $(this)
				.parents(".tabs")
				.find('[data-target="'.concat(tabTarget, '"]'))
				.addClass("tabs__content--active")
				.siblings()
				.removeClass("tabs__content--active");

			// Trigger event
			$(document).trigger("tabChanged", {
				activeTab: $activeTab[0],
				tabTarget: tabTarget,
			});
		});
	}

	// checkout button stick

	if ($win.width() < 768) {
		$win.on("scroll load", function () {
			var scrollOffset = 100;
			$(".js-hide-on-bottom").toggleClass(
				"is-visible",
				!(
					$doc.outerHeight() <=
					$win.scrollTop() + $win.outerHeight() + scrollOffset
				),
			);
		});
	}

	/** Register customer account page **/
	var $sts,
		$email,
		$error_txt = "";
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	jQuery("#create_customer").submit(function () {
		$sts = 0;
		$email = jQuery("#field-email").val();
		$error_txt = "";
		jQuery(".form--register").find(".errors").html("");
		$error_txt += '<div class="errors"><ul>';
		if (!regex.test($email)) {
			$sts = 1;
			$error_txt += "<li>Please enter valid email address</li>";
		}
		$error_txt += "</ul></div>";
		if ($sts == 1) {
			jQuery($error_txt).insertAfter(".form--register .form__head");
			return false;
		}
	});

	/* Address new and edit script work */
	jQuery(".btn--new").click(function () {
		jQuery("#edit_form_open").val("false");
		var edit_form = jQuery(".edit_form_open").val();
		jQuery(".edit_address_form").hide();
		jQuery(".default__address").hide();
		jQuery(".addresses__wrap").hide();
		jQuery(".customer_page_title").html("Add A New Address");
		jQuery(".form--address-new").show();
	});
	jQuery(".new-cancel").click(function () {
		jQuery("#edit_form_open").val("false");
		jQuery(".default__address").show();
		jQuery(".addresses__wrap").show();
		jQuery(".customer_page_title").html("Address");
		jQuery(".address").show();
	});

	jQuery(".btn--edit").click(function () {
		jQuery(".default__address").hide();
		jQuery(".address").hide();
		jQuery(".customer_page_title").html("Edit Address");
	});

	jQuery(".edit_cancel").click(function () {
		jQuery(".default__address").show();
		jQuery(".address").show();
		jQuery(".customer_page_title").html("Addresses");
		$(this).closest("form")[0].reset();
	});

	function parseMarkdownLinks(text) {
		const markdownLinkRegex = /\[([^\]]+)\]\((.*?)\)/g;
		const fragment = document.createDocumentFragment();
		let match;
		let lastIndex = 0;
		while ((match = markdownLinkRegex.exec(text)) !== null) {
			if (match.index > lastIndex) {
				fragment.appendChild(
					document.createTextNode(text.substring(lastIndex, match.index)),
				);
			}
			const anchor = document.createElement("a");
			anchor.href = match[2].trim();
			anchor.textContent = match[1];
			anchor.target = "_blank";
			anchor.rel = "noopener noreferrer";
			fragment.appendChild(anchor);
			lastIndex = markdownLinkRegex.lastIndex;
		}
		if (lastIndex < text.length) {
			fragment.appendChild(
				document.createTextNode(text.substring(lastIndex)),
			);
		}
		return fragment;
	}

	function initializeMarkdownLinks(force) {
		if (force) {
			document.querySelectorAll("[data-markdown-links]").forEach(function (element) {
				if (element._markdownLinksInitialized) {
					return;
				}
				const content = element.textContent;
				if (!content || !/\[[^\]]+\]\((.*?)\)/.test(content)) {
					return;
				}
				element.innerHTML = "";
				element.appendChild(parseMarkdownLinks(content));
				element._markdownLinksInitialized = true;
			});
		}

		document.querySelectorAll("[data-tooltip]").forEach(function (element) {
			if (!element.getAttribute("data-tooltip") || element._tooltipInitialized) {
				return;
			}

			let tooltipTimeout;

			function showTooltip() {
				const tooltipText = element.getAttribute("data-tooltip");
				if (!tooltipText) {
					return;
				}

				if (tooltipTimeout) {
					clearTimeout(tooltipTimeout);
					tooltipTimeout = null;
				}

				if (element._specTooltip) {
					element._specTooltip.remove();
					element._specTooltip = null;
				}

				const tooltip = document.createElement("div");
				tooltip.className = "spec-tooltip";
				tooltip.appendChild(parseMarkdownLinks(tooltipText));
				document.body.appendChild(tooltip);
				element._specTooltip = tooltip;

				const rect = element.getBoundingClientRect();
				const tooltipRect = tooltip.getBoundingClientRect();
				const margin = 0;
				let left = window.scrollX + rect.left;
				if (left + tooltipRect.width > window.scrollX + window.innerWidth - margin) {
					left = window.scrollX + window.innerWidth - tooltipRect.width - margin;
				}
				tooltip.style.left = `${Math.max(left, window.scrollX + margin)}px`;

				const updatedRect = tooltip.getBoundingClientRect();
				let top = window.scrollY + rect.top - updatedRect.height - margin;
				if (top < window.scrollY + margin) {
					top = window.scrollY + rect.bottom + margin;
				}
				if (
					window.innerWidth < 768 &&
					top + updatedRect.height > window.scrollY + window.innerHeight - margin
				) {
					top = window.scrollY + rect.top - updatedRect.height - margin;
				}
				tooltip.style.top = `${top}px`;

				tooltip.addEventListener("mouseenter", function () {
					if (tooltipTimeout) {
						clearTimeout(tooltipTimeout);
						tooltipTimeout = null;
					}
				});

				tooltip.addEventListener("mouseleave", function () {
					tooltipTimeout = setTimeout(function () {
						if (element._specTooltip) {
							element._specTooltip.remove();
							element._specTooltip = null;
						}
					}, 300);
				});

				tooltip.addEventListener("click", function (event) {
					event.stopPropagation();
				});
			}

			function hideTooltip() {
				tooltipTimeout = setTimeout(function () {
					if (element._specTooltip) {
						element._specTooltip.remove();
						element._specTooltip = null;
					}
				}, 300);
			}

			element._tooltipInitialized = true;
			element.style.cursor = "help";
			element.addEventListener("mouseenter", showTooltip);
			element.addEventListener("mouseleave", hideTooltip);
			element.addEventListener("click", function (event) {
				if (window.innerWidth >= 768) {
					return;
				}
				event.preventDefault();
				event.stopPropagation();
				if (element._specTooltip) {
					hideTooltip();
				} else {
					showTooltip();
				}
			});

			document.addEventListener("click", function (event) {
				if (
					!element._specTooltip ||
					element.contains(event.target) ||
					element._specTooltip.contains(event.target)
				) {
					return;
				}
				if (tooltipTimeout) {
					clearTimeout(tooltipTimeout);
				}
				element._specTooltip.remove();
				element._specTooltip = null;
			});
		});
	}

	document.addEventListener("DOMContentLoaded", function () {
		initializeMarkdownLinks(true);
	});

	const markdownObserver = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
				setTimeout(function () {
					initializeMarkdownLinks(true);
				}, 100);
			}
		});
	});

	markdownObserver.observe(document.body, {
		childList: true,
		subtree: true,
	});

	document.addEventListener("keydown", function (event) {
		if (event.key === "Escape") {
			document.querySelectorAll("[data-tooltip]").forEach(function (element) {
				if (element._specTooltip) {
					element._specTooltip.remove();
					element._specTooltip = null;
				}
			});
		}
	});
});

//counter.js
(function ($) {
	$.fn.countdown = function (options, callback) {
		var settings = $.extend(
			{
				date: null,
				offset: null,
				day: "Day",
				days: "Days",
				hour: "Hour",
				hours: "Hours",
				minute: "Minute",
				minutes: "Minutes",
				second: "Second",
				seconds: "Seconds",
			},
			options,
		);

		if (!settings.date) {
			$.error("Date is not defined.");
		}

		if (!Date.parse(settings.date)) {
			$.error(
				"Incorrect date format, it should look like this, 12/24/2012 12:00:00.",
			);
		}

		var container = this;

		var currentDate = function currentDate() {
			var date = new Date();
			var utc = date.getTime() + date.getTimezoneOffset() * 60000;
			var new_date = new Date(utc + 3600000 * settings.offset);
			return new_date;
		};

		function countdown() {
			var target_date = new Date(settings.date),
				current_date = currentDate();
			var difference = target_date - current_date;

			if (difference < 0) {
				clearInterval(interval);
				if (callback && typeof callback === "function") callback();
				return;
			}

			var _second = 1000,
				_minute = _second * 60,
				_hour = _minute * 60,
				_day = _hour * 24;

			var days = Math.floor(difference / _day),
				hours = Math.floor((difference % _day) / _hour),
				minutes = Math.floor((difference % _hour) / _minute),
				seconds = Math.floor((difference % _minute) / _second);
			var text_days = days === 1 ? settings.day : settings.days,
				text_hours = hours === 1 ? settings.hour : settings.hours,
				text_minutes = minutes === 1 ? settings.minute : settings.minutes,
				text_seconds = seconds === 1 ? settings.second : settings.seconds;
			days = String(days).length >= 2 ? days : "0" + days;
			hours = String(hours).length >= 2 ? hours : "0" + hours;
			minutes = String(minutes).length >= 2 ? minutes : "0" + minutes;
			seconds = String(seconds).length >= 2 ? seconds : "0" + seconds;
			container.find(".days").text(days);
			container.find(".hours").text(hours);
			container.find(".minutes").text(minutes);
			container.find(".seconds").text(seconds);
			container.find(".days_text").text(text_days);
			container.find(".hours_text").text(text_hours);
			container.find(".minutes_text").text(text_minutes);
			container.find(".seconds_text").text(text_seconds);
		}

		var interval = setInterval(countdown, 1000);
	};
})(jQuery);

// Tooltip functionality with markdown-style link support
(function() {
  // Function to parse markdown-style links: [text](url)
  function parseTooltipContent(text) {
    const linkRegex = /\[([^\]]+)\]\((.*?)\)/g;
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
      // Add text before the link
      if (match.index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
      }
      // Add the link
      const link = document.createElement('a');
      link.href = match[2].trim();
      link.textContent = match[1];
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      fragment.appendChild(link);
      lastIndex = linkRegex.lastIndex;
    }

    // Add remaining text
    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
    }

    return fragment;
  }

  function transformMarkdownLinks(element) {
    const text = element.textContent;
    if (!text || !/\[[^\]]+\]\((.*?)\)/.test(text)) return;
    element.innerHTML = '';
    element.appendChild(parseTooltipContent(text));
  }

  function initializeMarkdownLinks() {
    document.querySelectorAll('[data-markdown-links]').forEach((element) => {
      if (!element._markdownLinksInitialized) {
        transformMarkdownLinks(element);
        element._markdownLinksInitialized = true;
      }
    });
  }

  // Initialize tooltips on page load and after dynamic content changes
  function initializeTooltips() {
    document.querySelectorAll('[data-tooltip]').forEach((element) => {
      if (element.getAttribute('data-tooltip') && !element._tooltipInitialized) {
        element._tooltipInitialized = true;
        element.style.cursor = 'help';

        let hideTimeout;

        function showTooltip() {
          const text = element.getAttribute('data-tooltip');
          if (!text) return;

          // Clear any pending hide timeout
          if (hideTimeout) {
            clearTimeout(hideTimeout);
            hideTimeout = null;
          }

          // Remove existing tooltip (if any)
          if (element._specTooltip) {
            element._specTooltip.remove();
            element._specTooltip = null;
          }

          const tooltip = document.createElement('div');
          tooltip.className = 'spec-tooltip';
          tooltip.appendChild(parseTooltipContent(text));
          document.body.appendChild(tooltip);
          element._specTooltip = tooltip;

          // Position the tooltip
          const itemRect = element.getBoundingClientRect();
          const tipRect = tooltip.getBoundingClientRect();
          const margin = 0;

          let left = window.scrollX + itemRect.left;

          // First, set left position to determine actual width
          if (left + tipRect.width > window.scrollX + window.innerWidth - margin) {
            left = window.scrollX + window.innerWidth - tipRect.width - margin;
          }
          tooltip.style.left = `${Math.max(left, window.scrollX + margin)}px`;

          // Now measure again with correct width to get accurate height
          const updatedTipRect = tooltip.getBoundingClientRect();

          let top = window.scrollY + itemRect.top - updatedTipRect.height - margin;

          if (top < window.scrollY + margin) {
            top = window.scrollY + itemRect.bottom + margin;
          }

          // Additional check for mobile: if tooltip would go off-screen at bottom, force it above
          if (window.innerWidth < 768 && top + updatedTipRect.height > window.scrollY + window.innerHeight - margin) {
            top = window.scrollY + itemRect.top - updatedTipRect.height - margin;
          }

          tooltip.style.top = `${top}px`;

          // Add event listeners to tooltip itself
          tooltip.addEventListener('mouseenter', function() {
            // Clear hide timeout when hovering over tooltip
            if (hideTimeout) {
              clearTimeout(hideTimeout);
              hideTimeout = null;
            }
          });

          tooltip.addEventListener('mouseleave', function() {
            // Hide tooltip with delay when leaving tooltip
            hideTimeout = setTimeout(() => {
              if (element._specTooltip) {
                element._specTooltip.remove();
                element._specTooltip = null;
              }
            }, 300);
          });

          // Handle clicks on mobile - prevent tooltip from hiding immediately
          tooltip.addEventListener('click', function(e) {
            // Don't hide tooltip on click, let links work
            e.stopPropagation();
          });
        }

        function hideTooltip() {
          // Hide tooltip with delay
          hideTimeout = setTimeout(() => {
            if (element._specTooltip) {
              element._specTooltip.remove();
              element._specTooltip = null;
            }
          }, 300);
        }

        // Mouse events for desktop
        element.addEventListener('mouseenter', showTooltip);
        element.addEventListener('mouseleave', hideTooltip);

        // Touch events for mobile - use click instead of touchstart to avoid scroll blocking
        element.addEventListener('click', function(e) {
          // Only handle clicks on mobile (screen width < 768px)
          if (window.innerWidth >= 768) return;

          e.preventDefault();
          e.stopPropagation();

          if (element._specTooltip) {
            hideTooltip();
          } else {
            showTooltip();
          }
        });

        // Click outside to hide tooltip (for mobile)
        document.addEventListener('click', function(e) {
          if (element._specTooltip && !element.contains(e.target) && !element._specTooltip.contains(e.target)) {
            if (hideTimeout) {
              clearTimeout(hideTimeout);
            }
            element._specTooltip.remove();
            element._specTooltip = null;
          }
        });
      }
    });
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeTooltips();
    initializeMarkdownLinks();
  });

  // Re-initialize after dynamic content changes (for AJAX-loaded content)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Small delay to ensure elements are fully rendered
        setTimeout(function() {
          initializeTooltips();
          initializeMarkdownLinks();
        }, 100);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Close tooltips on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-tooltip]').forEach(element => {
        if (element._specTooltip) {
          element._specTooltip.remove();
          element._specTooltip = null;
        }
      });
    }
  });
})();


 // Script fix Safari bug when text selected
(function() {
	const userAgent = navigator.userAgent;
	const isSafari =
	/Safari/i.test(userAgent) &&
	!/(Chrome|Chromium|CriOS|FxiOS|Edg|OPR|OPiOS|Android|SamsungBrowser|DuckDuckGo|Brave)/i.test(userAgent);
	if (isSafari) {

		function clearSelectionAndForceRepaint() {
			if (window.getSelection) {
				if (window.getSelection().empty) {
					window.getSelection().empty();
				} else if (window.getSelection().removeAllRanges) {
					window.getSelection().removeAllRanges();
				}
			}

			document.body.style.transform = 'scale(1)';
			requestAnimationFrame(() => {
				document.body.style.transform = '';
			});
		}

		document.addEventListener('touchstart', clearSelectionAndForceRepaint, { passive: true });
		window.addEventListener('resize', clearSelectionAndForceRepaint);
	}
})();
	